
import { Subscription } from '@/types/subscription';

export const mapSupabaseDataToSubscription = (data: any): Subscription => {
  console.log("=== MAPPING FROM SUPABASE - ENHANCED DEBUG ===");
  console.log("Raw Supabase data:", JSON.stringify(data, null, 2));
  console.log("Business field analysis:", {
    is_business_raw: data.is_business,
    is_business_type: typeof data.is_business,
    business_name_raw: data.business_name,
    business_name_type: typeof data.business_name,
    is_annual_raw: data.is_annual,
    is_annual_type: typeof data.is_annual
  });
  
  // FIXED: Properly handle boolean conversion for is_business
  // The issue was that we weren't properly checking for true boolean values
  const isBusiness = data.is_business === true;
  
  const subscription: Subscription = {
    id: data.id,
    customerName: data.customer_name || data.customerName || '',
    email: data.email || '',
    address: data.address || '',
    postcode: data.postcode || '',
    binDay: data.bin_day || data.binDay || '',
    startDate: data.start_date || data.startDate || new Date().toISOString(),
    totalPaid: parseFloat(data.total_paid || data.totalPaid || 0),
    isAnnual: Boolean(data.is_annual || data.isAnnual),
    active: data.active !== undefined ? data.active : true,
    status: data.status || 'active',
    endDate: data.end_date || data.endDate || null,
    // FIXED: Business field handling - ensure proper boolean conversion
    isBusiness: isBusiness,
    // FIXED: Business name handling - preserve business name for business subscriptions
    businessName: isBusiness ? (data.business_name || data.businessName || null) : null,
    multipleDays: Boolean(data.multiple_days || data.multipleDays),
    // Enhanced address fields
    houseNumber: data.house_number || data.houseNumber || null,
    street: data.street || null,
    townCity: data.town_city || data.townCity || null,
    subscriptionType: data.subscription_type || data.subscriptionType || 'weekly',
    // Add any additional fields that might be in your Supabase table
    created_at: data.created_at,
    updated_at: data.updated_at
  };
  
  console.log("Final mapped subscription:", JSON.stringify({
    id: subscription.id,
    customerName: subscription.customerName,
    isBusiness: subscription.isBusiness,
    businessName: subscription.businessName,
    isAnnual: subscription.isAnnual,
    subscriptionType: subscription.subscriptionType,
    email: subscription.email,
    // New address fields
    houseNumber: subscription.houseNumber,
    street: subscription.street,
    townCity: subscription.townCity,
    address: subscription.address,
    postcode: subscription.postcode
  }, null, 2));
  
  console.log("Business mapping verification:", {
    originalIsBusiness: data.is_business,
    mappedIsBusiness: subscription.isBusiness,
    originalBusinessName: data.business_name,
    mappedBusinessName: subscription.businessName,
    businessLogicResult: isBusiness,
    finalIsBusinessCheck: subscription.isBusiness === true
  });
  
  if (subscription.isBusiness) {
    console.log("✅ BUSINESS SUBSCRIPTION MAPPED SUCCESSFULLY:", {
      id: subscription.id,
      customerName: subscription.customerName,
      businessName: subscription.businessName
    });
  }
  
  console.log("=== END MAPPING FROM SUPABASE - ENHANCED DEBUG ===");
  
  return subscription;
};

export const mapSubscriptionToSupabaseData = (subscription: Subscription) => {
  console.log("=== MAPPING TO SUPABASE - ENHANCED DEBUG ===");
  console.log("Input subscription:", JSON.stringify(subscription, null, 2));
  
  const result = {
    id: subscription.id,
    customer_name: subscription.customerName,
    email: subscription.email,
    address: subscription.address,
    postcode: subscription.postcode,
    bin_day: subscription.binDay,
    start_date: subscription.startDate,
    total_paid: subscription.totalPaid,
    is_annual: subscription.isAnnual,
    active: subscription.active,
    status: subscription.status,
    end_date: subscription.endDate,
    is_business: subscription.isBusiness,
    business_name: subscription.businessName,
    multiple_days: subscription.multipleDays,
    // Enhanced address fields
    house_number: subscription.houseNumber,
    street: subscription.street,
    town_city: subscription.townCity,
    subscription_type: subscription.subscriptionType || 'weekly'
  };
  
  console.log("Output Supabase data:", JSON.stringify(result, null, 2));
  console.log("Business field verification:", {
    inputIsBusiness: subscription.isBusiness,
    outputIsBusiness: result.is_business,
    inputBusinessName: subscription.businessName,
    outputBusinessName: result.business_name
  });
  console.log("Address field verification:", {
    inputHouseNumber: subscription.houseNumber,
    outputHouseNumber: result.house_number,
    inputStreet: subscription.street,
    outputStreet: result.street,
    inputTownCity: subscription.townCity,
    outputTownCity: result.town_city
  });
  console.log("=== END MAPPING TO SUPABASE - ENHANCED DEBUG ===");
  
  return result;
};
